<template>
  <v-card flat class="no-margins">
    <PersonEducations :initialMode="createNew"></PersonEducations>
    <div>
      <v-card flat class="mt-5">
        <h5>Yrkesbevis</h5>
        <v-data-table
          :headers="[
            {text: 'Yrke', sortable: false, filterable: false, value: 'profession', width: '340'},
            {text: 'Utfärdat', sortable: false, filterable: false, value: 'issuedOn', width: '120'},
            {text: 'Utfärdare', sortable: false, filterable: false, value: 'region', width: '170'},
            {text: 'STATUS', sortable: false, filterable: false, value: 'state', width: '160'},
            {text: '', filterable: false, value: 'actions'}
          ]"
          :items="TCs"
          :loading="isLoading"
          :items-per-page="itemsPerPage"
          hide-default-footer
          item-key="id"
        >
          <template slot="item.profession" slot-scope="props"> {{ props.item.profession.name }}</template>
          <template slot="item.region" slot-scope="props">{{ props.item.region.name }}</template>
          <template slot="item.issuedOn" slot-scope="props">{{ props.item.issuedOn | date }}</template>
          <template slot="item.state" slot-scope="props">
            <span v-if="!canApprove(props.item) && !props.item.approvedOn" class="small">
              Väntar på godkännande av annan regionär.
            </span>
            <span v-if="props.item.approvedOn" class="small"> Godkänd. </span>
          </template>
          <template slot="item.actions" slot-scope="props">
            <div class="d-flex justify-end">
              <v-btn
                v-if="canApprove(props.item) && !props.item.approvedOn"
                @click="
                  tcMode = 'approve'
                  tcModalObj = props.item
                  tcModal = true
                "
                :disabled="!canEducationUpdate"
              >
                <v-icon>$sl-like</v-icon>Godkänn
              </v-btn>
              <v-btn
                class="icon ml-4"
                color="secondary"
                @click="
                  tcMode = 'show'
                  tcModalObj = props.item
                  tcModal = true
                "
              >
                Visa / Ändra
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog v-model="tcModal" :max-width="tcMode === 'copy' ? '900px' : '600px'">
        <PersonTradeCertificateModal
          ref="tradeModal"
          :mode="tcMode"
          :title="'Utfärda yrkesbevis'"
          :tc="tcModalObj"
          @close="tcModal = false"
          @approve="approve"
        />
      </v-dialog>

      <v-dialog v-model="replacementCardModal" :max-width="'600px'">
        <PersonReplacementCard
          mode="create"
          :is-visible="replacementCardModal"
          @close="replacementCardModal = false"
          @approve="approve"
        />
      </v-dialog>
    </div>

    <!-- Person machine qualification component starts here -->
    <PersonMachineQualification :initialMode="createNew" />
    <!-- insctructor exemption component starts here -->
    <PersonInstructorExemptions :initialMode="createNew" />
    <!-- Person diverse qualifications starts here -->
    <PersonDiverseQualifications :initialMode="createNew" />
    <!-- Person machine card component starts here -->
    <PersonMachineCard :initialMode="createNew" :education="maEducation" :refresh="refreshMCList"/>
    <v-dialog v-model="createTradeCertCardModal" :max-width="'720px'">
      <CreateShowCard
          @hideCreateCardInfo="hideCreateCardInfo"
          :printCardId="0"
          :printOrders="printOrders"
          :isTradeCert="true"
          @deleted="hideCreateCardInfo"
          @close="hideCreateCardInfo"
          :mode="'create'"
        />
    </v-dialog>
    <div>
      <v-dialog v-model="AddNewModal" max-width="200px" content-class="fixed-bottom-right">
        <v-list class="ma-0 pa-0">
          <v-list-item v-for="(item, index) in sections" :key="index">
            <v-list-item-content>
              <v-list-item-title
                data-cy="item"
                @click="
                  createNew = item
                  AddNewModal = false
                "
                >{{ item }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-dialog>
      <v-btn
        fixed
        fab
        bottom
        right
        class="elevation"
        color="primary"
        data-cy="addNewCerticates"
        @click="
          AddNewModal = true
          createNew = ''
        "
        :disabled="!canEducationCreate"
      >
        <v-icon>$sl-add</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import API from '@/services/api'
import {pageSize} from '@/store/constants'
import {UserRules, CanIDo} from '@/components/mixins'
import PersonTradeCertificateModal from '@/components/person/PersonTradeCertificateModal'
import PersonMachineQualification from '@/components/person/PersonMachineQualification'
import PersonInstructorExemptions from '@/components/person/PersonInstructorExemptions'
import PersonMachineCard from '@/components/person/MachineCard/PersonMachineCard'
import PersonDiverseQualifications from '@/components/person/DiverseQualifications/List'
import PersonEducations from '@/components/person/PersonEducations'
import CreateShowCard from '@/components/person/MachineCard/CreateShowCard'
import PersonReplacementCard from '@/components/person/PersonReplacementCard'
import get from 'lodash/get'

export default {
  name: 'PersonTradeCertificates',
  mixins: [UserRules, CanIDo],
  data: () => ({
    createTradeCertCardModal: false,
    options: {},
    createNew: '',
    AddNewModal: false,
    maEducation: {id:-1},
    refreshMCList: false,
    tcModal: false,
    replacementCardModal: false,
    tcModalObj: {},
    tcMode: '',
    printOrders: [],
    itemsPerPage: pageSize,
    sections: ['Ersättningskort', 'Yrkesbevis', 'Maskinslag', 'Dispens', 'MKF handledarutbildning'],
    qualifyingTime: null
  }),

  components: {
    PersonTradeCertificateModal,
    PersonMachineQualification,
    PersonInstructorExemptions,
    PersonMachineCard,
    PersonEducations,
    PersonDiverseQualifications,
    CreateShowCard,
    PersonReplacementCard
  },

  watch: {
    createNew(newValue) {
      if (this.createNew == 'Yrkesbevis') {
        this.tcMode = 'create'
        this.tcModalObj = {}
        this.tcModal = true
      }
      else if (this.createNew == 'Beställ yrkesbeviskort') {
        this.createTradeCertCardModal = true        
      } else if(this.createNew === 'Ersättningskort') {
        this.replacementCardModal = true
      }
      
    }
  },

  computed: {
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole']),
    ...mapGetters('basic', ['getProfessionNameById', 'getRegionNameById', 'hasProfessionOrientations']),

    TCs() {
      if (this.selectedPerson.tradeCertificates) {
        return this.selectedPerson.tradeCertificates
      } else {
        return []
      }
    },
    MQs() {
      if (this.selectedPerson.machinequalifications) {
        return this.selectedPerson.machinequalifications
      } else {
        return []
      }
    },

    qualifyingTimeMeetApprovalCriteria() {
      return get(this, 'qualifyingTime', null) && 
        Boolean(!get(this, 'qualifyingTime.isApprovedByInstructor', false) && !get(this, 'qualifyingTime.isApproved', false))
    }
  },

  asyncComputed: {
    canEducationUpdate(){
      return this.canIDo('education', 'update');
    },
    canEducationCreate(){
      return this.canIDo('education', 'create');
    }
  },

  created() {
    this.init()
    this.getQualificationTime()
  },
  methods: {
    ...mapActions('person', ['setSelectedPerson']),
    /**
     * @vuese
     * Used to approve trade certificate
     * @arg The argument is integer values representing person who approved
     */
    canApprove(item) {
      if (item && item.region && item.createdById) {
        return this.canUserApprove(item.region.id, item.createdById)
      }
      return false
    },

    init(){     
      this.getPersonPrintOrders()
      if(this.selectedPerson.tradeCertificates.find(f => f.approvedById>0))
      {
        this.sections.push('Beställ yrkesbeviskort')
      }
    },

    async getPersonPrintOrders() {
      this.mcMode = 'create'
      this.printOrders = []

      await API.getPersonPrintOrders(this.selectedPerson.id)
        .then(res => {
          res.data.forEach(p => {
            let type = ''
            let machines = ''
            if (p.displayType === 'Maskinintyg') {
              let machineCertificateMachines = get(p, 'print.machineCertificateMachines', [])
              machines = machineCertificateMachines.map(m => m.machine.name).join(', ')
              type = 'Maskinkort: '
            } else {
              type = p.displayType
            }
            this.printOrders.push({
              id: p.id,
              printOrderState: p.printOrderState,
              createdBy: p.createdBy,
              createdAt: p.createdAt,
              displayType: type + machines
            })
          })
        })
        .catch(error => {
          const response = error?.response ?? error 
          console.log('There was an error:', response)
        })
    },

    getQualificationTime() {
      if (!(this.$route && this.$route.params && this.$route.params.id)) return
      API.getPersonQualificationTime(this.$route.params.id)
        .then(res => { 
          let hasQualificationTime = false
          res.data.educations.forEach(e => {

            this.qualifyingTime = get(this, 'TCs', []).find(o => (
                get(o, 'profession.id', null) === e.professionId && !get(o, 'approvedById', null)
              )
            ) ? e.qualificationTime : null

            if (this.hasProfessionOrientations(e.professionId)) {
              this.maEducation=e              
              return (hasQualificationTime = true)
            }
            hasQualificationTime = false
          })
          if (hasQualificationTime) {
            this.sections.push('Beställ maskinkort')
          }
        })
        .catch(error => {
          console.log('get document error, ', error)
        })
    },

    hideCreateCardInfo() {
      this.createTradeCertCardModal = false
      this.refreshMCList = !this.refreshMCList
    },

/**
     * @vuese
     * Used to approve trade certificate
     * @arg The argument is integer values representing person who approved
     */
    async approve(tc) {
      if (!this.canApprove(tc)) {
        this.$events.fire('showError', 'Du saknar behörighet att godkänna detta utfärdande.')
        return
      }

      if ( this.qualifyingTimeMeetApprovalCriteria ) {
        const res = await this.$dialog.confirm({
          title: 'OBS!',
          text: 'Lärlingens kvalificeringstid kommer att godkännas efter att ett yrkesbevis har utfärdats.',
          actions: [
            {text: 'Avbryt', key: false, icon: '$sl-cancel', outlined: true},
            {text: 'Jag förstår', key: true, icon: '$sl-like'},
          ]
        })
  
        if (res !== true)
          return
      }

      API.approveTradeCertificate(tc.id)
        .then(res => {
          tc.approvedOn = new Date()
          tc.approvedById = this.currentUser.id
          tc.approvedBy = {}
          tc.approvedBy.id = this.currentUser.id
          tc.approvedBy.firstName = this.currentUser.firstName
          tc.approvedBy.lastName = this.currentUser.lastName
          API.getPerson(this.selectedPerson.id)
            .then(response => {
              /**
               * @vuese
               * Used to update local store with the person data
               * @arg the argument is an object representing person
               */
              this.setSelectedPerson(response.data)
            })
            .catch(error => {
              console.log('There was an error:', error.response)
            })
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => this.tcModal = false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>